import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_BASE_URL } from "../ApiConfig";
import style from "../../css/admin/Totaluser.module.css";
import { getSecureToken } from "../ApisService/apiService";

const LIMIT = 20;

const UserContactUs = () => {
  const [users, setUsers] = useState([]);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");
  const [expandedMessages, setExpandedMessages] = useState(new Set());
  const observer = useRef();

  const fetchUsers = async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    const { secrettoken, ts } = await getSecureToken();

    try {
      const response = await axios.get(
        `${API_BASE_URL}Contact_us/User_Contact_us.php?limit=${LIMIT}&offset=${offset}`,
        {
          headers: {
            "X-TOKEN": secrettoken,
            "X-TIMESTAMP": ts,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === "success") {
        const newUsers = Array.isArray(response.data.data) ? response.data.data : [];
        setUsers((prev) => [...prev, ...newUsers]);
        setOffset((prev) => prev + LIMIT);
        if (newUsers.length < LIMIT) setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const lastUserRef = (node) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchUsers();
        }
      },
      { threshold: 1.0 }
    );
    if (node) observer.current.observe(node);
  };

  const toggleExpand = (index) => {
    setExpandedMessages((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) newSet.delete(index);
      else newSet.add(index);
      return newSet;
    });
  };

  const filteredUsers = users.filter(
    (user) =>
      user.name.toLowerCase().includes(search.toLowerCase()) ||
      user.email.toLowerCase().includes(search.toLowerCase()) ||
      user.phone.includes(search)
  );

  return (
    <div className={style.container}>
      <h2 className={style.heading}>📩 Contact Us Queries</h2>

      <div className={style.filterContainer}>
        <input
          type="text"
          placeholder="Search by Name, Email, or Mobile..."
          className={style.searchInput}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className={style.tableContainer}>
        <table className={style.userTable}>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Message</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user, index) => {
                const isLast = index === filteredUsers.length - 1;
                const isExpanded = expandedMessages.has(index);
                return (
                  <tr key={index} ref={isLast ? lastUserRef : null}>
                    <td>{index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.phone}</td>
                    <td>{user.email}</td>
                    <td>
                      <div
                        style={{
                          maxHeight: isExpanded ? "auto" : "1.4em",
                          overflow: "hidden",
                    
                          wordBreak: "break-word",
                          lineHeight: "1.4em",
                        }}
                      >
                        {user.message}
                      </div>
                      {user.message.length > 50 && (
                        <button
                          onClick={() => toggleExpand(index)}
                          style={{
                            border: "none",
                            background: "none",
                            color: "#007bff",
                            cursor: "pointer",
                            padding: 0,
                            fontSize: "0.85rem",
                          }}
                        >
                          {isExpanded ? "Less ▲" : "More ▼"}
                        </button>
                      )}
                    </td>
                    <td>{user.created_at}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className={style.noData}>
                  🚫 No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {loading && <p style={{ textAlign: "center", padding: "1rem" }}>Loading more...</p>}
      </div>
    </div>
  );
};

export default UserContactUs;
